  <div class="row" soho-personalize>
        <div class="column full">

          <!-- THEME FIELD -->
          <div class="field" *ngIf="!usingPortalTheme">
            <label for="theme" class="label">{{'Theme' | translate}}</label>
            <select soho-dropdown
                noSearch
                id="theme"
                attr.data-automation-id="{{themeSelectAttributes[0].value + '-select'}}"
                [attributes]="themeSelectAttributes"
                name="theme"
                [(ngModel)]="settings.theme"
                (change)="theme($event)"
            >
              <ng-container *ngFor="let theme of availableThemes">
                <option value={{theme.id}} [selected]="theme.id === settings.theme">
                  {{theme.name}}
                </option>
              </ng-container>
            </select>
          </div>

          <!-- THEME COLOR FIELD -->
          <div class="field" *ngIf="!usingPortalColor">
            <label for="colors" class="label">{{ 'Colors' | translate }}</label>
            <select soho-dropdown
                noSearch
                id="colors"
                name="colors"
                attr.data-automation-id="{{colorSelectAttributes[0].value + '-select'}}"
                [attributes]="colorSelectAttributes"
                [(ngModel)]="settings.color"
                (change)="color($event)"
            >
              <ng-container *ngFor="let color of themeColors | keys">
                <option
                    value="{{color.value.id}}"
                    [attr.data-hex]="color.value.value"
                    [selected]="color.value.id === settings.color"
                    [attr.data-icon]="JSON.stringify({ icon: 'swatch', class: color.value.backgroundColorClass + ' swatch'})"
                >
                  {{color.value.name}}
                </option>
              </ng-container>
            </select>
          </div>

          <div class="field switch">
            <input
                    type="checkbox"
                    id="apply-color-to-menu"
                    data-automation-id="lm-settings-dialog-apply-color-to-menu"
                    name="apply-color-to-menu"
                    [(ngModel)]="settings.applyColorToMenu"
            >
            <label for="apply-color-to-menu">{{ 'ApplyColorToMenu' | translate }}</label>
          </div>

          <div class="field switch">
            <input
                type="checkbox"
                id="use-compact-layout"
                data-automation-id="lm-settings-dialog-use-compact-layout"
                name="use-compact-layout"
                [(ngModel)]="settings.useCompactFormLayout"
            >
            <label for="use-compact-layout">{{ 'UseCompactLayout' | translate }}</label>
          </div>

          <div class="field switch">
            <input
                type="checkbox"
                id="accessibility-mode"
                data-automation-id="lm-settings-dialog-accessibility-mode"
                name="accessibility-mode"
                [(ngModel)]="settings.accessibilityMode"
            >
            <label for="accessibility-mode">{{ 'AccessibilityMode' | translate }}</label>
          </div>

          <!-- Automatic Searching -->
          <div class="field">
            <label for="filterBarMode" class="label">{{ 'SearchMode' | translate }}</label>
            <select soho-dropdown
                noSearch
                id="filterBarMode"
                name="filterBarMode"
                attr.data-automation-id="{{searchModeSelectAttributes[0].value + '-select'}}"
                [attributes]="searchModeSelectAttributes"
                [(ngModel)]="settings.automaticSearch"
                (change)="setFilterBarMode($event)"
            >
              <option value="active">{{ 'Active' | translate }}</option>
              <option value="passive">{{ 'Passive' | translate }}</option>
            </select>
          </div>

          <!-- PREFERRED APPLICATION FIELD -->
          <div class="field" *ngIf="displayPreferredApplication">
            <label for="preferredApp" class="label">{{ 'PreferredApplication' | translate }}</label>
            <select soho-dropdown noSearch id="preferredApp" name="preferredApp" [(ngModel)]="settings.preferredWebApp" (change)="preferredApp($event)">
              <option value="">{{ 'NoPreferred' | translate }}</option>
              <option *ngFor="let app of availableApps" value={{app.webAppName}} [selected]="app.webAppName === settings.preferredWebApp">{{app.webAppTitle}}</option>
            </select>
          </div>

          <!-- APPLICATION DISPLAY FIELD -->
          <div class="field" *ngIf="isDeveloper || !isProduction">
            <label for="appDisplay" class="label">{{ 'DisplayApps' | translate }}</label>
            <select soho-dropdown noSearch id="appDisplay" name="appDisplay" [(ngModel)]="settings.appDisplay" (change)="appDisplay($event)">
              <option value="4_0">In 4.0</option>
              <option value="3_5">In 3.5</option>
              <option value="webapp">{{ 'ByWebappSetting' | translate }}</option>
              <!--<option value="override">In 4.0 w/3.5 override for unsupported</option>-->
            </select>
          </div>

          <!-- Toast message position -->
          <div class="field">
            <label for="toastMessagePosition" class="label">{{ 'ToastMessagePosition' | translate }}</label>
            <select soho-dropdown
              noSearch
              id="toastMessagePosition"
              attr.data-automation-id="{{toastMessagePositionSelectAttributes[0].value + '-select'}}"
              [attributes]="toastMessagePositionSelectAttributes"
              name="toastMessagePosition"
              [(ngModel)]="settings.toastMessagePosition"
              (change)="toastMessagePosition($event)"
            >
              <option value="BLANK" *ngIf="toastMessageHasCustomPosition"></option>
              <option value="DEFAULT">{{ 'Default' | translate }}</option>
              <option value="TOP_LEFT">{{ 'TopLeft' | translate }}</option>
              <option value="TOP_RIGHT">{{ 'TopRight' | translate }}</option>
              <option value="BOTTOM_LEFT">{{ 'BottomLeft' | translate }}</option>
              <option value="BOTTOM_RIGHT">{{ 'BottomRight' | translate }}</option>
            </select>
          </div>

          <!-- Toast message duration -->
          <div class="field">
            <label for="toastMessageDuration" class="label">{{ 'ToastMessageDuration' | translate }}</label>
            <select soho-dropdown
              noSearch
              id="toastMessageDuration"
              attr.data-automation-id="{{toastMessageDurationSelectAttributes[0].value + '-select'}}"
              [attributes]="toastMessageDurationSelectAttributes"
              name="toastMessageDuration"
              [(ngModel)]="settings.toastMessageDuration"
              (change)="toastMessageDuration($event)">
              <option value="BLANK"></option>
              <option value="SHORTER">{{ 'Shorter' | translate }}</option>
              <option value="DEFAULT">{{ 'Default' | translate }}</option>
              <option value="LONGER">{{ 'Longer' | translate }}</option>
            </select>
          </div>

          <div class="field switch" *ngIf="showDeletedRecordEnabled">
            <input
              type="checkbox"
              id="show-deleted-records"
              name="show-deleted-records"
              data-automation-id="lm-settings-dialog-show-deleted-records"
              [(ngModel)]="showDeletedRecords">
            <label for="show-deleted-records">{{ 'ShowDeleteRecordsSetting' | translate }}</label>
          </div>

          <!-- PDF/CSV Max Wait time -->
          <div class="field">
            <label for="maxWaitTimePDFCSV" class="label">{{ 'MaxWaitTimePDFCSV' | translate }}</label>
            <select soho-dropdown
                noSearch
                id="maxWaitTimePDFCSV"
                name="maxWaitTimePDFCSV"
                attr.data-automation-id="{{maxWaitTimePDFSelectAttributes[0].value + '-select'}}"
                [attributes]="maxWaitTimePDFSelectAttributes"
                [(ngModel)]="settings.maxWaitPDFCSV"
                (change)="setMaxWaitPDFCSV($event)"
            >
              <option value="0">{{ 'NeverWait' | translate }}</option>
              <option value="5">{{ 'FiveS' | translate }}</option>
              <option value="10">{{ 'TenS' | translate }}</option>
              <option value="15">{{ 'FifteenS' | translate }}</option>
            </select>
          </div>

          <!-- PDF/CSV Initial Record Limit -->
          <div class="field">
            <label for="export-record-limit-default" class="label">{{ 'ExportRecordLimitDefault' | translate }}</label>
            <select soho-dropdown
              noSearch
              id="export-record-limit-default"
              name="exportRecordLimitDefault"
              data-automation-id="lm-settings-dialog-export-record-limit-default"
              attr.data-automation-id="{{exportRecordLimitDefaultAttributes[0].value + '-select'}}"
              [attributes]="exportRecordLimitDefaultAttributes"
              [(ngModel)]="settings.exportDefaultRecordLimit"
            >
              <option value="system">{{ 'ExportRecordLimitDefaultSystemOption' | translate }}</option>
              <option value="no-limit">{{ 'ExportRecordLimitDefaultNoLimitOption' | translate }}</option>
            </select>
          </div>

          <!-- KEYBOARD SHORTCUTS -->
          <div class="field" *ngIf="displayShortcuts">
            <a soho-hyperlink (click)="openKeyboardShortcutsDialog()">{{ 'KeyboardShortcuts' | translate }}</a>
          </div>
        </div>
      </div>

<div #keyboardDialogPlaceholder id="keyboardDialogPlaceholder" class="lmDialogPlaceholder"></div>
